import ModalContainer from './ModalContainer';
import OpenModal from './OpenModal';

export {
    ModalContainer,
    OpenModal,
};


// WEBPACK FOOTER //
// ./src/components/modal/index.ts